<script lang="ts" setup>
import type { IMailboxItemDateProps } from '@/types/components/mailbox/MailboxItemDate';
import { computed } from 'vue';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import useMailboxSharedProvides from '@/composables/mailbox/useMailboxSharedProvides';

dayjs.extend(utc);
dayjs.extend(timezone);

const { injectMailboxUserDetails } = useMailboxSharedProvides();
const { userDetails } = injectMailboxUserDetails();

const props = defineProps<IMailboxItemDateProps>();

const messageDate = computed(() => {
  if (!userDetails.value?.timezone) {
    return '--';
  }
  const date = dayjs(props.date).tz(userDetails.value?.timezone);

  if (props.fullDate) {
    return date.format('DD.MM.YYYY / HH:mm');
  }

  const now = dayjs().tz(userDetails.value?.timezone);

  if (date.isSame(now, 'day')) {
    return date.format('HH:mm');
  } else if (date.isSame(now, 'week')) {
    return date.format('ddd DD.MM');
  }

  return date.format('DD.MM.YY');
});
</script>

<template>
  <span>
    {{ messageDate }}
  </span>
</template>
